module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-26-5f5a3b454a7aef503fa14fae0b04325a.svg";